// src/components/Charts/pie/MostUsedIcdsPieChart.jsx
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AnalyticsPieCard from './AnalyticsPieCard';
import { BASE_PIE_COLORS, OTHERS_COLOR } from '../../../constants/ColorsPalette';
import { urls } from '../../config/variables';
import AppContext from '../../../contexts/app-context';
import AuthContext from '../../../contexts/auth-context';

export default function CptIssues({ chartId }) {
  const { t } = useTranslation('analytics');
  useContext(AppContext);
  useContext(AuthContext);

  return (
    <AnalyticsPieCard
      chartId={chartId}
      endpoint={urls.CPT_ISSUES}
      i18n={{
        seriesName: 'CPT Issues',
        centerLabel: 'CPT Issues',
        detailsButton: 'CPT Issues Details',
        dialogTitle: 'All CPTs Issues',
        entityName: 'CPT Issues',
        noData: t('NoData') || 'No data',
      }}
      nameKeys={['issue_name', 'name']}
      valueKeys={['issue_count', 'count']}
      parseResponse={(data) => {
        // New format: array
        if (Array.isArray(data)) return { rows: data, otherSum: 0 };
        // Old format with other_icds sum
        console.error('Unexpected response shape for CPTs Issues:', data);
        return { rows: [], otherSum: 0 };
      }}
      baseColors={BASE_PIE_COLORS}
      othersColor={OTHERS_COLOR}
      othersLabel="Others"
      useTopNWithOthers
      topN={14}
    />
  );
}